<template>
  <div class="container-wrapper" :class="is_buy ? 'container-buy' : ''">
    <goodsDetailInfo
      v-if="!is_buy"
      :goodsData="goodsData"
      :productCase="goodsData.product"
      :teacherList="teacherList"
      :is_buy="is_buy"
      unitName="course"
      :currentSpecs="goodsData.product.case[0]"
      :titleObj="{}"
    />

    <div class="goods-content">
      <van-tabs
        v-model="tabsActiveIndex"
        :scrollspy="!is_buy"
        sticky
        :offset-top="offsetTop"
        class="jbc-tabs"
        :class="tabsList.length <= 1 ? 'hideTabNav' : ''"
      >
        <van-tab v-for="(item, index) in tabsList" :title="item.name" :key="index">
          <!-- 商品目录 -->
          <div class="goods-catalog">
            <div class="container">
              <div class="header" v-if="item.listKey !== 'intro' && !is_buy">
                <span class="title">{{ item.name }}</span>
                <span class="subtitle">{{ item.list.length }}个</span>
              </div>
              <!-- 介绍页 -->
              <div class="container-row" v-if="item.listKey == 'intro'">
                <div v-html="bodyInfo(item.list)" class="imgBox"></div>
              </div>
              <CatalogList v-else :list="item.list" :type="item.listKey" :isBuy="is_buy" />
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import CatalogList from '@/components/Goods/CatalogList'
import GoodsDetailInfo from '@/components/Goods/GoodsDetailInfo.vue'
import goodsCommon from '@/views/goods/mixins/goodsCommon'

export default {
  name: 'ActionCourse',
  props: ['is_buy', 'goodsData', 'unitName', 'courseNo'],
  components: { CatalogList, GoodsDetailInfo },
  data() {
    return {
      offsetTop: 0,
    }
  },
  mixins: [goodsCommon],
  watch: {
    courseNo(newV, oldV) {
      console.log(this.goodsData.id)
      this.updatePage()
    },
  },
  mounted() {
    this.updatePage()
  },
  methods: {
    updatePage() {
      this.dataGoodsFormatMiddle(this.goodsData)
      // 获取老师列表
      this.getTeacherDetail(this.goodsData.teacher)

      let boxH = document.querySelector('#course-action-sheet ').offsetTop
      let boxTop = document.querySelector(
        '#course-action-sheet .van-action-sheet__header'
      ).offsetHeight
      this.offsetTop = boxH + boxTop
    },
  },
}
</script>

<style scoped lang="scss">
.goods {
  &-catalog {
    border-bottom: 0.2rem solid #f7f8fa;
    background: #fff;

    .header {
      padding-top: 0.5rem;
      margin-bottom: -0.1rem;

      .title {
        font-size: $font36;
        font-weight: bold;
      }

      .subtitle {
        font-size: $font28;
        color: #919499;
        margin-left: 0.2rem;
      }
    }

    .image {
      display: block;
      width: 100%;
    }
  }
}

/deep/ {
  .van-sticky.van-sticky--fixed {
    @include maxWidth();
  }

  .jbc-tabs {
    .van-tabs__wrap {
      height: 1.6rem;

      .van-tabs__nav {
        // padding-top: 0.1rem;
        padding-bottom: 0;
        box-sizing: border-box;
      }
    }

    .van-tabs__line {
      bottom: 0.2rem;
    }
  }

  .imgBox img {
    max-width: 100%;
  }

  .hideTabNav {
    .van-tabs__wrap {
      display: none !important;
    }
  }
}

.van-tab__pane {
  &:nth-last-child(1) {
    min-height: 90vh;
    background-color: #fff;

    .goods-catalog {
      border: none;
    }
  }
}

.container-buy {
  .goods-catalog {
    border: none;
  }
}

.container-wrapper {
  padding-bottom: 1.7rem;
  min-height: 60vh;
  background-color: #fff;
  box-sizing: border-box;

  &.container-buy {
    .van-tab__pane {
      &:nth-last-child(1) {
        min-height: auto;
      }
    }
  }
}

.van-action-sheet {
  max-height: 90%;
}

::v-deep {
  .goods-card:nth-child(1) .goods-card-title {
    display: none;
  }

  .goods-specs-item .icon {
    display: none;
  }
}
</style>
